import { Avatar } from "ui";

import { DriverSelectorItemProps } from "../DriverSelector.types";

import styles from "../DriverSelector.module.scss";

export const DriverSelectorItem = ({
  image,
  name
}: DriverSelectorItemProps) => {
  return (
    <div className={styles.driverSelector__item}>
      <Avatar
        image={image}
        dimensions={{ width: 24, height: 24, borderRadius: "50%" }}
      />
      <p>{name}</p>
    </div>
  );
};
